export { default } from './InfoCardsContainer';
